import styles from "./FullNameAvatar.module.scss"

const FullNameAvatar = ({ src, fullName }) => {
  return (
    <div className="d-flex align-items-center gap-2">
      <img src={src || ""} alt="Profile" className={styles.profileImage} />
      {fullName}
    </div>
  )
}

export default FullNameAvatar
